const noop = () => {
  /**
   * No Operation
   */
};

export default noop;
